module.exports = __webpack_public_path__ + "img/sol2.248dfa77.png";